import { defineComponent as _defineComponent } from 'vue'
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import { useAlert } from "@rmp/core/composables/useAlert";
import { ref, watch } from "vue";

export interface AlertProps {
	customBackgroundColor?: string;
	customIcon?: string;
	iconColor?: string;
	colorClass?: string;
	type?: string;
	text?: string;
	closable?: boolean;
	right?: boolean;
	timeout: number;
	icon?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpAlertsSnackbar',
  props: {
    customBackgroundColor: null,
    customIcon: null,
    iconColor: null,
    colorClass: null,
    type: null,
    text: null,
    closable: { type: Boolean, default: true },
    right: { type: Boolean, default: false },
    timeout: null,
    icon: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as { customBackgroundColor?: string, customIcon?: string, iconColor?: string, colorClass?: string, type?: string, text?: string, closable: boolean, right: boolean, timeout: number, icon?: string };



const { backgroundColor } = useAlert(props);

const shown = ref<boolean>(true);



const close = () => {
	emit("close");
};

watch(shown, (value) => {
	if(!value) {
		close();
	}
});

return { __sfc: true,props, backgroundColor, shown, emit, close, RmpBtn, RmpIcon }
}

})